/**
 * Start work from anywhere (slice 3.2): the two callables behind the
 * "Process" buttons on the Processing tab and the job card's Capture tab
 * (functions handlers/processing/startWork.ts). Admin or rig_operator on
 * the server; the screens show the buttons to admins and crew, and a crew
 * login without the rig operator role gets the server's refusal in words.
 *
 *   getWorkOptions({ jobId, sn? })  what can be started there, and on which computers
 *   startWork({ kind, jobId, sn?, machineUid?, priority?, requestId })
 *
 * The fixture server (vite.fixture.config.js) swaps this file for
 * src/test/mocks/workCallables.js.
 */
import { callable } from "../firebase.js";

const call = async (name, payload, options) => {
  const fn = callable(name, options);
  const result = await fn(payload);
  return result.data;
};

// A phone on venue Wi-Fi: the options fail fast; a job's press may make tasks and runs longer.
const OPTIONS_TIMEOUT = { timeout: 20000 };
// One capture may make its task first (two storage steps of up to 30 s each, then transactions).
const START_ONE_TIMEOUT = { timeout: 150000 };
const START_JOB_TIMEOUT = { timeout: 300000 };

export const work = {
  getWorkOptions: ({ jobId, sn }) => call("getWorkOptions", { jobId, ...(sn ? { sn } : {}) }, OPTIONS_TIMEOUT),
  startWork: ({ kind = "process", jobId, sn, machineUid, priority, requestId }) =>
    call("startWork", {
      kind,
      jobId,
      ...(sn ? { sn } : {}),
      ...(machineUid ? { machineUid } : {}),
      ...(priority !== undefined ? { priority } : {}),
      ...(requestId ? { requestId } : {}),
    }, sn ? START_ONE_TIMEOUT : START_JOB_TIMEOUT),
};
